export default __webpack_public_path__ + "static/media/map_sketch.4d0b509c.png";